<template>
    <div class="bg">
        <div class="container">
            <div class="blue-bind">
                <div class="back-img"></div>
                <img class="top-img" src="../assets/images/influencers_sheet_top@2x.png" alt="">
            </div>
            <div class="sign-out-container" v-if="sucess">
                <div class="sign-container">
                    <div class="sucess-ing">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70px"
                            height="70px">
                            <path fill-rule="evenodd" fill="rgb(119, 198, 75)"
                                d="M34.984,69.71 C16.173,69.71 0.924,53.821 0.924,35.10 C0.924,16.194 16.173,0.949 34.984,0.949 C53.794,0.949 69.43,16.194 69.43,35.10 C69.43,53.821 53.794,69.71 34.984,69.71 ZM34.976,10.629 C21.519,10.629 10.608,21.535 10.608,34.999 C10.608,48.454 21.519,59.369 34.976,59.369 C48.435,59.369 59.345,48.454 59.345,34.999 C59.345,21.535 48.435,10.629 34.976,10.629 ZM34.871,46.798 C34.796,46.885 34.738,46.980 34.655,47.63 C33.934,47.784 33.44,48.232 32.113,48.410 C30.551,48.731 28.864,48.290 27.652,47.78 C27.504,46.930 27.388,46.762 27.262,46.600 L19.734,39.72 C17.820,37.158 17.820,34.55 19.734,32.141 C21.648,30.227 24.751,30.227 26.665,32.141 L31.158,36.634 L42.866,24.926 C44.782,23.10 47.888,23.10 49.804,24.926 C51.720,26.842 51.720,29.949 49.804,31.865 L34.871,46.798 Z" />
                        </svg>
                    </div>
                    <div class="sign-title" style="font-size: 32px;line-height: 1.2;margin: 20px 0 10px;">
                        {{ $t('m.bind.postTitle') }}
                    </div>
                    <div class="sign-text">
                        {{ $t('m.bind.postSpan') }}
                    </div>

                    <div class="submit-box">
                        <a @click="backHome()" class="sub">
                            <div> {{ $t('m.bind.postHome') }}</div>
                        </a>
                    </div>
                    <!-- <div class="bottom-timer">
                    还有 <a class="greener" href="">{{ time - 1 }}</a> 秒后跳转
                </div> -->
                </div>
            </div>

            <div class="container-box" v-else>
                <div class="top-title">
                    <p class="title">{{ $t('m.bind.title') }}</p>
                    <p class="title-txt">{{ $t('m.bind.span') }}</p>
                </div>
                <div class="img-box" v-if="this.$i18n.locale == 'zh'">
                    <img class="id-step-bg" src="../assets/images/id_step_bg@2x.png" alt="" srcset="">
                    <div class="step">
                        <div class="txt">1. 在游戏内点击“游戏设置”</div><img src="../assets/images/id_step_01@2x.png" alt="">
                    </div>
                    <div class="step two">
                        <div class="txt">2. 在“通用”选项卡内拉到页面底部<br class="br" />找到“我的客服编号”，点击查看
                        </div><img src="../assets/images/id_step_02@2x.png" alt="">
                    </div>
                    <div class="step">
                        <div class="txt">3. 点击“显示”图标<br class="br" />显示你的客服编号，点击编号复制
                        </div><img src="../assets/images/id_step_03@2x.png" alt="">
                    </div>
                </div>
                <div class="img-box zh" v-else>
                    <img class="id-step-bg" src="../assets/images/id_step_bg@2x.png" alt="" srcset="">
                    <div class="step">
                        <div class="txt">1. Click "Settings" within the game</div><img
                            src="../assets/images/id_step_01_en@2x.png" alt="">
                    </div>
                    <div class="step two">
                        <div class="txt">2. Scroll to the bottom of the "General" tab<br class="br" />find "My Customer
                            Service ID", and click "Inspect"
                        </div><img src="../assets/images/id_step_02_en@2x.png" alt="">
                    </div>
                    <div class="step">
                        <div class="txt">3. Click the View icon to reveal your Customer Service ID or click the ID itself to
                            conveniently copy it
                        </div><img src="../assets/images/id_step_03_en@2x.png" alt="">
                    </div>
                </div>
                <div class="inp-box">
                    <div class="ibox">
                        <div class="inp-txt">{{ $t('m.bind.inputTitle') }}</div>
                        <div class="input-box">
                            <span class="alert" v-if="alert"><svg data-v-700d1935="" version="1.1" id="图层_1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                                    y="0px" viewBox="0 0 22 22" xml:space="preserve"
                                    style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                                    <g data-v-700d1935="">
                                        <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                                        <path data-v-700d1935=""
                                            d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                                            class="st0"></path>
                                        <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                                    </g>
                                </svg>{{ alert }}</span>
                            <input class="bind-input" :placeholder="$t('m.bind.inputPlace')" v-model="id" />

                        </div>

                    </div>

                    <div class="btn-box">
                        <Btn :color="'#e6e6e6'" :text="$t('m.bind.jump')" :route="'/'"></Btn>
                        <span class="btn" @click="binding()">{{ $t('m.bind.post') }}</span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Btn from "../components/Btn.vue";
export default {

    data() {
        return {
            id: '',
            back: '',
            alert: '',
            sucess: false,
            time: 6
        }
    },
    components: {
        Btn
    },

    mounted() {
        if (!this.$store.state.login) {
            this.$router.push("/login")

        } else {
            this.$watch(
                () => this.$store.state.login,
                (newVal, oldVal) => {
                    if (!newVal) {
                        this.$router.push("/login")
                    }
                }
            )
        }
        if (this.$route.query.custId) {
            this.back = true
            this.id = this.$route.query.custId
            console.log(this.$route.query.custId.length);
        }
    },
    methods: {
        backHome() {
            this.$router.back()
        },
        go() {
            let timer = setInterval(() => {
                this.time--
                if (this.time == 0) {
                    clearInterval(timer)
                    this.$router.push('/tickets/my-tickets')
                }
            }, 1000);
        },
        binding() {
            if (this.id.trim().length >= 7 && this.id.trim().length <= 8) {
                console.log("12333");
                this.alert = ''
                this.$axios({
                    method: 'post',
                    url: this.$backend.host,
                    headers: {
                        'x-source': 'Nemo',
                        jwt: localStorage.getItem('result_code'),
                        // jwt: "eyJhbGciOiJQUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnYiOiJTdGFuZGFsb25lIiwiZXhwIjoxNjY1NDk0ODUwLCJpYXQiOjE2NjU0NjYwNTAsImlkIjoiUktHTUM3IiwiaXNzIjoiUmVjcmVhdGUiLCJqdGkiOiI3cmhsSE0xdkM1VzlicTBYS2ctNFJ3Iiwiand0VHlwZSI6Ik9mZmljaWFsU2l0ZSIsIm5iZiI6MTY2NTQ2NjA1MCwicGxhdGZvcm1fdHlwZSI6MCwic3ViIjoiSHVydEVhY2hPdGhlciJ9.mDht7GqEFDuXbL9zX1JrXcUmvy2b2bExanXA_sNngd2w9r4meeIVj49NgecF39bw4o5Q8hTva4YJLJOiirk2eI4R_HtYF77acTbYwXlGk_xb1ZzV6nGjTJ-c6IAkg0-aQi913fptAryYQKXfLy2iMJGXs4pFTgWEpSmWgCor6e6wrEAJytUCq-DBS9dWVAEhOk2eRB_FyNooEwaKX5oqnJQDG980ZnVjv1PFrhHs7keTSVpmuvBLm9z5uI0wY3fkf6eTU6juanHi16aUCuviIHz-FrXdTor3Pn0kdQq4RQdTmu4OqNX3lA_lRoenADcFLwHADtlneuvHZEBsJbeqUg"
                    },
                    data: {
                        'Query': '{checkCustIdGame(custIdGame: "' + this.id.trim() + '") { ok }}'
                    }
                }).then(res => {
                    console.log(res);
                    console.log(res.data.code == "3216");
                    if (res.data.code == "3216") {
                        this.alert = this.$t('m.bind.alertBind')
                    } else
                        if (res.data.code == 0 && res.data.result.checkCustIdGame.ok) {

                            this.$axios({
                                method: 'post',
                                url: this.$backend.host,
                                headers: {
                                    'x-source': 'Nemo',
                                    jwt: localStorage.getItem('result_code'),
                                    // jwt: "eyJhbGciOiJQUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnYiOiJTdGFuZGFsb25lIiwiZXhwIjoxNjY1NDk0ODUwLCJpYXQiOjE2NjU0NjYwNTAsImlkIjoiUktHTUM3IiwiaXNzIjoiUmVjcmVhdGUiLCJqdGkiOiI3cmhsSE0xdkM1VzlicTBYS2ctNFJ3Iiwiand0VHlwZSI6Ik9mZmljaWFsU2l0ZSIsIm5iZiI6MTY2NTQ2NjA1MCwicGxhdGZvcm1fdHlwZSI6MCwic3ViIjoiSHVydEVhY2hPdGhlciJ9.mDht7GqEFDuXbL9zX1JrXcUmvy2b2bExanXA_sNngd2w9r4meeIVj49NgecF39bw4o5Q8hTva4YJLJOiirk2eI4R_HtYF77acTbYwXlGk_xb1ZzV6nGjTJ-c6IAkg0-aQi913fptAryYQKXfLy2iMJGXs4pFTgWEpSmWgCor6e6wrEAJytUCq-DBS9dWVAEhOk2eRB_FyNooEwaKX5oqnJQDG980ZnVjv1PFrhHs7keTSVpmuvBLm9z5uI0wY3fkf6eTU6juanHi16aUCuviIHz-FrXdTor3Pn0kdQq4RQdTmu4OqNX3lA_lRoenADcFLwHADtlneuvHZEBsJbeqUg"
                                },
                                data: {
                                    'Query': 'mutation { bindCustIdGame (custId: "' + this.id + '") { ok } }'
                                }
                            }).then(res => {
                                console.log(res);
                                if (res.data.result.bindCustIdGame.ok) {
                                    this.sucess = true
                                    document.cookie = "cust_id_game=" + this.id + ';path = /';
                                } else {
                                    this.alert = this.$t('m.alertBind.alertBind')
                                }
                            })
                        } else {
                            this.alert = this.$t('m.bind.emply')
                        }


                })
            } else if (this.id.trim().length == 0) {
                this.alert = this.$t('m.bind.emply')
            } else {
                this.alert = this.$t('m.bind.emply')
            }
        },


        getCookie(name) {
            var strcookie = document.cookie; //获取cookie字符串
            var arrcookie = strcookie.split("; "); //分割
            //遍历匹配
            for (var i = 0; i < arrcookie.length; i++) {
                var arr = arrcookie[i].split("=");
                if (arr[0] == name) {
                    return arr[1];
                }
            }
            return "";
        },
    }
}
</script>
<style lang="scss" scoped>
input::placeholder {
    color: #c5c8c9;
}

.container {
    padding: 0 0 10px;

    .blue-bind {
        position: relative;
        background-color: #6190ff;
        height: 23%;
        min-height: 120px;

        .top-img {
            max-width: 796px;
            width: 90%;

            position: relative;
            bottom: -42px;
            display: block;
            margin: 0 auto;
        }

        .back-img {
            background-image: url(../assets/images/texture_animal_head.png);
            background-size: auto 200%;
            opacity: .08;
            background-position: center;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
        }


    }

    .container-box {
        width: 100%;
        // background: url("../assets/images/submit_bg.png")center repeat;
    
        .top-title {
            font-family: "MohrRounded Heavy", "FZLanTYK_Black", "Microsoft YaHei", sans-serif;
            text-align: center;


            .title {
                color: #e66d25;
                font-size: 40px;
                line-height: 1.2;
                padding: 80px 0 0px;
                margin-bottom: 20px;
            }

            .title-txt {
                font-size: 18px;
                color: #5c5956;
                font-family: "Nunito-Bold", 'HYZhengYuan-85W', Microsoft YaHei, sans-serif;
                max-width: 555px;
                margin: 0 auto;

                &:last-child {
                    padding-bottom: 50px;
                }
            }
        }

        .img-box {
            font-family: 'MohrRounded Black', "FZLanTYK_Black", Microsoft YaHei, sans-serif;
            max-width: 1080px;
            margin: 0 auto;
            border-bottom: 2px solid #e6e6e6;
            border-top: 2px solid #e6e6e6;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            text-align: center;
            padding-bottom: 10px;
            position: relative;

            .id-step-bg {
                position: absolute;
                width: 100%;
                top: 20%;
            }

            &.zh {
                .txt {
                    margin-bottom: 25px;
                }

                .id-step-bg {
                    top: 23%;
                }
            }

            .step {
                z-index: 1;
                width: 25%;
                margin: 0 2%;
                font-size: 18px;
                color: #898989;
                margin-top: 30px;
                font-family: "Nunito-Bold", "HYZhengYuan-85W", Microsoft YaHei, sans-serif;

                img {
                    width: 100%;

                }



                .txt {

                    height: 100px;
                }

                &.two {
                    width: 44%;
                }
            }
        }

        .ibox {
            display: flex;
            align-items: center;
        }

        .alert {
            font-family: 'Nunito-Bold', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
            color: #ee6060;
            font-size: 12px;
            text-align: left;
            position: absolute;
            left: 0px;
            top: 50px;

            svg {
                margin: 0 5px 0 0;
                position: relative;
                top: 2px;
            }
        }

        .btn-box {
            height: 60px;
            margin-top: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            align-content: center;
            flex-wrap: wrap;
            margin: 40px auto 0;
            align-content: center;
            align-items: center;

            a {
                margin: 0 10px;
            }

            #btn {
                padding: 10px 36px 10px;
                font-size: 16px;
                line-height: 27px;
            }

            .btn {
                min-width: 26px;
                margin: 0 10px;
                height: 30px;
                font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
                color: #3f4141;
                font-size: 16px;
                text-align: center;
                background-color: #ffdd40;
                line-height: 27px;
                border-radius: 14px;
                padding: 11px 36px 3px;
                transition: all 0.25s ease;
                cursor: pointer;

                &:hover {
                    background-color: #ffc640;
                }
            }
        }

        .inp-box {
            padding-top: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #383b42;
            font-size: 18px;
            font-family: 'MohrRounded Black', 'HYZhengYuan-85W', Microsoft YaHei, sans-serif;
            flex-direction: column;
            align-content: center;
            align-items: center;

            .ibox {
                max-width: 600px;
            }

            div {
                width: 100%;

            }

            .inp-txt {
                color: #5c5956;
                margin-top: 5px;
                width: 130px;
            }

            .input-box {
                display: flex;
                padding: 0 15px;
                margin-top: 2px;
                width: 100%;
                position: relative;
                min-height: 45px;
                background-color: #fff;
                border-radius: 17px;
                border: 2px solid rgba(63, 65, 65, 0.1803921569);
                flex-direction: column-reverse;
                justify-content: center;



                input {
                    resize: none;
                    width: 100%;
                    border: 0;
                    font-size: 16px;
                    outline: none;
                    background-color: #3f414100;
                    color: #3f4141;
                    font-family: 'Nunito-Bold', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
                }
            }
        }

    }
}

.bg {
    width: 100%;
    flex-grow: 1;
}

.submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: MohrRounded Heavy, "FZLanTYK_Black", Microsoft YaHei, sans-serif;
    margin: 10px auto 0;
}

.submit-box div {
    min-width: 160px;
    height: 50px;
    font-family: MohrRounded Heavy, "FZLanTYK_Black", Microsoft YaHei, sans-serif;
    color: #3f4141;
    font-size: 18px;
    text-align: center;
    background-color: #ffc640;
    transition: all 0.5s ease;
    border-radius: 17px;
    line-height: 50px;
}

.submit-box div:hover {
    background-color: #ffdd40;
}




.bottom-timer {
    position: relative;
    margin: 10px auto;
    bottom: -15px;
    font-family: 'Nunito-Bold', "HYZhengYuan-65W", "Microsoft YaHei",
        sans-serif;
    text-align: center;
}

.bottom-timer .greener {
    color: #77c64b;
}

.sign-container .sign-title {
    color: #e66d25;
    font-family: 'MohrRounded Black', HYZhengYuan-65W, Microsoft YaHei, sans-serif
}

.sign-container .bottom-timer {
    font-size: 16px;
    color: #898989;
}

.sucess-ing svg path {
    width: 68px;
    height: 68px;
}

.sign-container.success {
    width: 600px;
    padding: 60px 50px;
}

.sign-out-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 80px 5% 20px;
    padding: 0 10%;
}

.sign-container {
    position: relative;
    padding: 54px 50px;
    max-width: 500px;
    width: 100%;

    border-radius: 48px;
    box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 4%), 0px 8px 16px 0px rgb(0 0 0 / 4%),
        inset 0px -2px 3px 0px rgb(122 122 122 / 10%),
        inset 0px 3px 3px 0px rgb(255 255 255 / 90%);
    background-color: #fcfcfa;
}



.submit-box .sub div {
    cursor: pointer;
}

.sign-container .sucess-ing {
    display: flex;
    justify-content: center;
}

.sign-title {
    font-size: 40px;
    text-align: center;
    color: #3f4141;
    padding: 10px 0 17px 0;
}

@media screen and (max-width:1200px) {
    .container .container-box .inp-box .ibox {
        margin: 0 10%;
        width: 80%;
        min-width: unset;
    }

    .container .container-box div.img-box {
        padding-top: 3vw;
    }

    .container .container-box .inp-box div {
        width: 180px;
    }

    .container .container-box .inp-box .input-box {
        width: 100%;
    }

    .container .container-box .img-box .step {
        min-width: 300px;
    }

    .container .container-box .img-box .step.two {
        min-width: 380px;
    }

    .container .container-box .top-title {
        margin: 0 10%;
    }

    .container .container-box .img-box .id-step-bg {
        display: none;
    }

    .container .container-box .img-box .step.two {
        width: 58%;
    }

    .container .container-box .img-box .step {
        width: 42%;
    }

    .container .container-box .img-box .step .txt {
        height: unset;
        margin-bottom: 30px;
    }

    .container .container-box .img-box {
        margin: 0 10%;
        flex-direction: column;
        align-items: center;
        /* text-align: center; */
        padding-bottom: 10px;
        position: relative;

    }

    .container .container-box .inp-box .btn-box {
        width: 100%;
    }

    .br {
        display: none;
    }
}

@media screen and (max-width:900px) {



    .container .container-box .top-title .title {
        // padding: 8vw 0 3vw;
    }

    .container .blue-bind .top-img {

        bottom: -4.6vw;
    }
}

@media screen and (max-width:540px) {
    .container .container-box .top-title .title {
        padding: 60px 0 10px;
        font-size: 32px;
    }

    .bind-input {
        margin-left: -1%;
    }

    .container .container-box .inp-box {
        padding-top: 40px;
    }

    .container .container-box .alert {
        top: 65px;
        width: 100%;
        text-align: center;
    }

    .container .blue-bind .top-img {
        bottom: -52px;

        // width: 100%;
        width: 340px;
    }

    .container .container-box .top-title .title-txt:last-child {
        padding-bottom: 40px;
    }

    .container .container-box .img-box .step .txt {
        margin-bottom: 30px;

    }

    .container .container-box .img-box .step {
        margin-top: 30px;
    }

    .container .container-box .inp-box .input-box input {
        font-size: 20px;
        padding: 0 15px 0 0;
        margin: 0;
        text-align:center;
    }

    .container .container-box .inp-box .input-box {
        min-height: 60px;
    }

    .container .container-box .inp-box .inp-txt {
        text-align: center;
        margin-bottom: 20px;
    }

    .container .container-box .inp-box {
        // width: calc(100% - 30px);
        // margin: 0 5%;
    }

    .container .container-box .inp-box .input-box {
        width: calc(100% - 30px);

    }

    .container .container-box .inp-box .ibox {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 10%;
    }

    .container .container-box .img-box .step.two .txt {
        margin: 0 5% 30px;
    }
}</style>